"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexToRgba = exports.remToPx = exports.pxToRem = void 0;
const text_1 = require("../text");
const pxToRem = (pxValue, base = 16) => {
    const remValue = 1 / base * parseFloat(pxValue);
    return remValue;
};
exports.pxToRem = pxToRem;
const remToPx = (remValue, base = 16) => {
    const pxValue = parseFloat(remValue) / (1 / base);
    return pxValue;
};
exports.remToPx = remToPx;
const hexToRgba = (hex, opacity = 1) => {
    const hexString = hex.replace('#', '');
    const hexArr = (0, text_1.chunkString)(hexString, hexString.length / 3);
    const rgba = hexArr ?
        hexArr.map(hexUnity => parseInt(hexString.length % 2 ? hexUnity + hexUnity : hexUnity, 16)).concat(isFinite(opacity) ? opacity : 1).join(',') :
        '0,0,0,1';
    return `rgba(${rgba})`;
};
exports.hexToRgba = hexToRgba;
//# sourceMappingURL=index.js.map